import { cn } from '@simplywallst/ui-core/next';

export const richTextClasses = cn([
  'max-w-none',
  'text-solid',
  'text-base',
  '[word-break:break-word]',
  'prose',
  'prose-p:text-base',
  'prose-h3:text-hero',
  'prose-h4:text-mega',
  'prose-h5:text-xl',
  'prose-headings:font-medium',
  'prose-headings:!mt-x2',
  'prose-headings:!mb-x1',
  'prose-headings:text-pretty',
  'prose-li:text-base',
  'prose-img:my-0',
]);
